import { COLORS } from 'helpers/globals'

const hide = { display: 'none' }

const sceneThumbnail = {
    display: 'inline-block',
    maxWidth: '33%',
    height: 98,
    padding: '0 .5rem',
    cursor: 'pointer',
    '& img': {
      width: '100%',
      height: '100%',
      border: `1px solid ${COLORS.quaternary}`
    }
  }

const sceneSelectorButton = {
    fontSize: '1.4rem',
    color: COLORS.primary,
    width: '50%',
    display: 'inline-block',
    marginBottom: '.5rem',
    textAlign: 'center',
    '&:hover': { cursor: 'pointer' }
  }

export default {
  hide,
  container: {
    height: 303,
    overflowY: 'auto'
  },
  sceneThumbnail,
  sceneThumbnailCurrent: {
    ...sceneThumbnail,
    '& img': { border: `3px solid ${COLORS.primary}` }
  },
  sceneSelectorButton,
  uploadSceneButton: {
    ...sceneSelectorButton,
    borderRight: '1px solid #ccc'
  },
  uploadSceneButtonFull: {
    ...sceneSelectorButton,
    borderRight: '1px solid #ccc',
    width: '100%',
    paddingRight: 0
  }
}



// WEBPACK FOOTER //
// ./src/components/SceneSelector/style.js